module.exports = __webpack_public_path__ + "static/media/datazip-logo-black.c131b20e.svg";